<div class="config-section">
    <div class="loading-skeleton" *ngIf="loading">
        <app-skeleton-loader *ngFor="let i of [1, 2, 3, 4]" height="48px" borderRadius="8px"></app-skeleton-loader>
    </div>

    <ng-container *ngIf="!loading">
        <!-- Active departments block -->
        <div class="department-block">
            <h3 class="block-title">{{ 'permit.config.departments.active_title' | translate }}</h3>

            <div class="empty-state" *ngIf="!activeDepartments.length">
                {{ 'permit.config.departments.empty_active' | translate }}
            </div>

            <div class="department-card" *ngFor="let department of activeDepartments">
                <div class="department-content">
                    <div class="department-info">
                        <div class="department-title">{{ departmentName(department) }}</div>

                        <div class="manager-chips" *ngIf="hasManagers(department)">
                            <span class="manager-chip" *ngFor="let initials of managerInitials(department)">{{ initials }}</span>
                            <span class="manager-chip manager-chip--extra" *ngIf="extraManagerCount(department)">
                                +{{ extraManagerCount(department) }}
                            </span>
                        </div>

                        <div class="department-badge department-badge--warning" *ngIf="!hasManagers(department)"
                             [title]="'permit.config.departments.managers_hint' | translate">
                            {{ 'permit.config.departments.no_managers_badge' | translate }}
                        </div>
                    </div>

                    <div class="department-actions">
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="onEdit(department)">
                                <span>{{ 'permit.config.common.edit' | translate }}</span>
                            </button>
                            <button mat-menu-item (click)="confirmArchive(department)">
                                <span>{{ 'permit.config.departments.archive' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>

        <!-- Archived departments block -->
        <div class="department-block">
            <h3 class="block-title">{{ 'permit.config.departments.archived_title' | translate }}</h3>

            <div class="empty-state" *ngIf="!archivedDepartments.length">
                {{ 'permit.config.departments.empty_archived' | translate }}
            </div>

            <div class="department-card department-card--archived" *ngFor="let department of archivedDepartments">
                <div class="department-content">
                    <div class="department-info">
                        <div class="department-title">{{ departmentName(department) }}</div>
                    </div>

                    <div class="department-actions">
                        <button mat-icon-button [matMenuTriggerFor]="archivedMenu" class="more-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #archivedMenu="matMenu">
                            <button mat-menu-item (click)="onUnarchive(department)">
                                <span>{{ 'permit.config.departments.unarchive' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
